(function ($) {
    $(document).ready(function () {
        var modal = $('#my_geotab_interactive_map_modal');
        var modalContent = $('#my_geotab_interactive_map_modal .modal-content-body');
        var btn = $('.interactive__map-sidebar-body-section img');
        var close = $('#my_geotab_interactive_map_modal .close');

        $(".interactive__map-sidebar-body").on("click", ".interactive__map-sidebar-body-section img", function(){
        // btn.click(function () {
            console.log("tesat");
            var imgSrc = $(this).attr('src');
            var imgAlt = $(this).attr('alt');
            var html = '';
            if (imgAlt.length) {
                html = `<img src="${imgSrc}" /><p>${imgAlt}</p>`;
            } else {
                html = `<img src="${imgSrc}" />`;
            }
            modalContent.html(html);
            modal.addClass("shown");
            modal.fadeIn(200);
        })
        close.click(function () {
            modal.removeClass("shown");
            modal.fadeOut(200);
        })

        $('#my_geotab_interactive_map_modal .modal-bg').click(function () {
            modal.removeClass("shown");
            modal.fadeOut(200);
        });

        $(document).keydown(function (event) {
            if (event.keyCode == 27) {
                modal.removeClass("shown");
                modal.fadeOut(200);
            }
        });
    });
})(jQuery);